import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

/**
 * Socket.IO lives on the HTTP server root, not under /api.
 * If VITE_API_BASE_URL is e.g. http://localhost:5000/api, we connect to http://localhost:5000.
 */
function getSocketServerUrl() {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || '';
  const trimmed = baseUrl.replace(/\/$/, '');
  if (trimmed.endsWith('/api')) {
    return trimmed.slice(0, -4);
  }
  return trimmed || window.location.origin;
}

/**
 * Connect to notification socket when token exists; call onNotification when a new notification is received.
 */
export function useNotificationSocket(onNotification) {
  const socketRef = useRef(null);
  const onNotificationRef = useRef(onNotification);
  onNotificationRef.current = onNotification;

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const socketUrl = getSocketServerUrl();

    const socket = io(socketUrl, {
      path: '/socket.io',
      auth: { token },
      transports: ['polling', 'websocket'],
    });
    socketRef.current = socket;

    socket.on('notification', (payload) => {
      if (onNotificationRef.current) onNotificationRef.current(payload);
    });

    socket.on('connect_error', (err) => {
      console.warn('[Notifications] Socket connect_error:', err.message);
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, []);

  return () => {
    if (socketRef.current) socketRef.current.disconnect();
  };
}
